import { ILoadingState } from "./interface";

export default <ILoadingState> {
	loadingCount: 0
}